import { connect } from 'react-redux';
import IncidentsView from '../components/views/Incidents';
import { SET_UNRESOLVED_INCIDENTS_COUNT } from '../redux/actions/types';
import type { State } from '../types';

const mapStateToProps = (state: State) => ({
  currentUser: state.currentUser,
  projects: state.projects.items,
  users: state.users,
});

const mapDispatchToProps = (dispatch: any) => ({
  onUpdateUnresolvedCount: (count: number) => {
    dispatch({ type: SET_UNRESOLVED_INCIDENTS_COUNT, payload: count });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(IncidentsView as any);
